import React from 'react';
import { connect } from 'react-redux';
import {
    BrowserRouter as Router,
    Route,
    Switch
  } from "react-router-dom";

import './scss/App.scss';

import Game from './js/screens/Game';
import Home from './js/screens/Home';

const App = () => {
    return (
        <Router>
            <Switch>
                <Route path={[`/wordgrid/game/:gridSizeInSlug/:listIdInSlug`, "/wordgrid/game"]}>
                    <Game />
                </Route>
                <Route path="*">
                    <Home />
                </Route>
            </Switch>
            
        </Router>        
    )
};

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})


export default connect(
    mapStateToProps, 
    mapDispatchToProps
)(App);